import script from "./PublicLink.vue?vue&type=script&setup=true&lang=js"
export * from "./PublicLink.vue?vue&type=script&setup=true&lang=js"

import "./PublicLink.vue?vue&type=style&index=0&id=6689de6a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6689de6a"]])

export default __exports__